/* eslint-disable max-len */
function CopySvg(props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7283" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="black" />
        </mask>
        <g mask="url(#mask0_38017_7283)">
            <rect x="2.625" y="6" width="9.375" height="9.375" rx="1.5" stroke="#39404D" strokeWidth="1.125" />
            <path d="M12.1759 12.375H13.5C14.3284 12.375 15 11.7034 15 10.875V4.5C15 3.67157 14.3284 3 13.5 3H7.125C6.29657 3 5.625 3.67157 5.625 4.5V5.86297" stroke="#39404D" strokeWidth="1.125" />
        </g>
    </svg>;
}

export default CopySvg;
